<template>
    <div class='pswp' tabIndex='-1' role='dialog' aria-hidden='true'>

        <div class='pswp__bg'/>
        <div class="pswp_car" v-if="getCarObj.lot_id !== undefined">
            <div class="theme-table-container table-container center-column">
                <table class="auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth"
                       id="enquiry-table">
                    <thead>
                    <tr class="top-header" id="resultTable">
                        <th>Photo</th>
                        <th>Lot No</th>
                        <th>Date</th>
                        <th>Model</th>
                        <th>Grade</th>
                        <th>Price</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="picture-td" data-label="photo">
                            <div class="image is-64x64">
                                <img :src="getCarObj.images + '&w=320'">
                            </div>
                        </td>
                        <td>{{ getCarObj.lot_num }}</td>
                        <td>{{ getCarObj.auct_date }}</td>
                        <td>{{ getCarObj.manuf_name }} {{ getCarObj.model_name }}</td>
                        <td>{{ getCarObj.grade }}</td>
                        <td>{{ getCarObj.price_start }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class='pswp__scroll-wrap'>

            <div class='pswp__container'>
                <div class='pswp__item'/>
                <div class='pswp__item'/>
                <div class='pswp__item'/>
            </div>
            <div class='pswp__ui pswp__ui--hidden'>
                <div class='pswp__top-bar'>
                    <div class='pswp__counter'/>
                    <button class='pswp__button pswp__button--close'
                            title='Close (Esc)'/>
                    <button class='pswp__button pswp__button--share'
                            title='Share'/>
                    <button class='pswp__button pswp__button--fs'
                            title='Full Screen'/>
                    <button class='pswp__button pswp__button--zoom'
                            title='Zoom Out/In'/>
                    <div class='pswp__preloader'>
                        <div class='pswp__preloader__icn'>
                            <div class='pswp__preloader__cut'>
                                <div class='pswp__preloader__donut'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                        class='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
                    <div class='pswp__share-tooltip'/>
                </div>
                <button class='pswp__button pswp__button--arrow--left'
                        title='Previous (arrow left)'/>
                <button class='pswp__button pswp__button--arrow--right'
                        title='Next (arrow right)'/>
                <div class='pswp__caption'>
                    <div class='pswp__caption__center'/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import events from 'v-photoswipe/src/events.js'
    import PhotoSwipeFn from 'photoswipe'
    import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js'
    export default {
        name: 'v-photoswipe',
        props: {
            isOpen: {
                type: Boolean,
                default: false
            },
            items: {
                type: Array,
                required: true
            },
            options: {
                type: Object,
                default: {},
                preload: [1,1]
            },

        },
        watch: {
            items: {
                handler: function (val, oldVal) {
                    if (this.pswp && this.isOpen) {
                        this.pswp.invalidateCurrItems()
                    }
                },
                deep: true
            },
            isOpen (val, oldVal) {
                if (val) {
                    this.openPhotoSwipe(this.items, this.options)
                } else {
                    this.close()
                }
            }
        },
        methods: {
            openPhotoSwipe (items, options) {
                let pswpElement = this.$el
                this.pswp = new PhotoSwipeFn(pswpElement, PhotoSwipeUIDefault, items, options)
                events.forEach(e => {
                    this.pswp.listen(e, (...args) => {
                        args.unshift(this)
                        this.$emit(e, [...args])
                    })
                })
                this.pswp.init()
            },
            close () {
                this.$store.dispatch('setResultGalleryCar', '')
                if (this.pswp) {
                    this.pswp.close()
                }
            }
        },
        mounted () {
            if (this.isOpen) {
                this.openPhotoSwipe(this.items, this.options)
            }
        },
        beforeDestroy () {
            this.close()
        },
        computed: {
            getCarObj() {
                return this.$store.getters.getResultGalleryCar
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Result/Gallery.vue